module.exports = __webpack_public_path__ + "static/media/YM03_4.a2e49cf2.jpg";